module.exports = __webpack_public_path__ + "img/mxf.99c87144.png";